import { DisclaimerReferenceBadge, ReferenceBadgeProps } from "@volkswagen-onehub/components-core";
import { DisclaimerLayerAppearanceV2 } from '@volkswagen-onehub/layer-manager';
import React, { useContext } from "react";
import { LayerContext, useDisclaimerLayer } from "../Layers";
import { DisclaimerModal } from "./DisclaimerModal";

interface Props {
  marker: string | number;
  text: string;
  id: string;
  variant?: ReferenceBadgeProps["variant"];
}

export const DisclaimerMarker = ({ marker, text, id, variant = "default" }: Props) => {

  const { closeLayer } = useContext(LayerContext);

  const openDisclaimerLayer = useDisclaimerLayer(`${id}-disclaimer-layer`, {
    onClose:() => closeLayer(`${id}-disclaimer-layer`),
    appearance: DisclaimerLayerAppearanceV2.LIGHT,
    userCloseable: false
  });

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    openDisclaimerLayer(((close) => <DisclaimerModal marker={marker} text={text} close={close} />))
  };

  return (
    <sup style={{ whiteSpace: "nowrap"}}>
      &#8288;
      <DisclaimerReferenceBadge
        onClick={e => handleClick(e)}
        variant={variant}
      >
        { marker }
      </DisclaimerReferenceBadge>
    </sup>
  );
};
